module.exports = __webpack_public_path__ + "img/Maswings.ac1adf04.png";